export default function putSslCertificateReducer
  (state = { error:'', success:'', processing:false}, action)
{
  switch (action.type) {
    case 'PUT_SSL_CERTIFICATES_SUCCESS':
      return {...state, ...{success: action.success}};

    case 'PUT_SSL_CERTIFICATES_ERROR':
      return {...state, ...{error: action.error}};

    case 'PUT_SSL_CERTIFICATES_PROCESSING':
      return {...state, ...{processing: action.processing}};

    default: return state;
  }
}